export default __webpack_public_path__ + "static/media/synchronize.842863a5.png";